/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class BulkTagRemediationRequest {
    getFixupPrototypeFunction() { return BulkTagRemediationRequest.fixupPrototype; }

    static newInstance(model: Partial<BulkTagRemediationRequest>): BulkTagRemediationRequest {
        let obj = Object.assign(new BulkTagRemediationRequest(), model);
        BulkTagRemediationRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<BulkTagRemediationRequest>): BulkTagRemediationRequest {
        if (!model) return null;
        return BulkTagRemediationRequest.newInstance(<BulkTagRemediationRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: BulkTagRemediationRequest) {
        if (!obj) return;

        models.BulkTagRemediationRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: BulkTagRemediationRequest): boolean {
        Object.setPrototypeOf(obj, BulkTagRemediationRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.remediation_inputs) {
            for (let val of this.remediation_inputs) {
                models.TagsRemediation.fixupPrototype(val);
            }
        }
    }

    /**
     * Service Account Id
     */
    service_account_id: string;

    remediation_inputs: Array<models.TagsRemediation>;

}
